module.exports = __webpack_public_path__ + "img/97.66118c40.png";